import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import { BimEmpty } from './BimEmpty';
import { bindAction } from './bindAction';
import { bindEvent } from './bindEvent';
import { useScript } from '@/shared/hooks';
const Bim = ({ style, viewToken, actionRef: propsActionRef, onMouseClick, onMouseRightClick, onTreeNodeClick, onReady, toolbars, }) => {
    const bimRef = useRef();
    useImperativeHandle(propsActionRef, () => bimRef.current);
    useEffect(() => {
        const loaderConfig = new BimfaceSDKLoaderConfig();
        loaderConfig.viewToken = viewToken;
        BimfaceSDKLoader.load(loaderConfig, (viewMetaData) => {
            const webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
            webAppConfig.domElement = document.getElementById('bimId');
            webAppConfig.enableToggleContextMenuDisplay = false;
            if (toolbars) {
                webAppConfig.Toolbars = toolbars;
            }
            const app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
            app.addView(viewToken);
            bimRef.current = app.getViewer();
            bimRef.current?.enableGlowEffect(true);
            bindEvent(bimRef, {
                onMouseClick,
                onMouseRightClick,
                onTreeNodeClick,
            });
            if (propsActionRef) {
                // @ts-ignore
                bindAction(propsActionRef, bimRef);
            }
            bimRef.current?.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, () => {
                bimRef.current?.render();
                if (onReady) {
                    onReady();
                }
            });
        }, (e) => {
            console.log('failure_load:', e);
        });
        return () => {
            if (bimRef.current) {
                bimRef.current?.hideView(viewToken);
                bimRef.current?.render();
                bimRef.current?.removeView(viewToken);
            }
        };
    }, [
        onMouseClick,
        onMouseRightClick,
        onReady,
        onTreeNodeClick,
        propsActionRef,
        toolbars,
        viewToken,
    ]);
    return _jsx("div", { id: "bimId", style: style });
};
export const Bimface = (props) => {
    const status = useScript('https://static.bimface.com/api/BimfaceSDKLoader/BimfaceSDKLoader@latest-release.js');
    return useMemo(() => {
        return _jsx(_Fragment, { children: status === 'ready' ? _jsx(Bim, { ...props }) : BimEmpty });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.viewToken, status]);
};
